jQuery(document).ready(function($) {

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header').outerHeight();

     setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-up').addClass('nav-down');
            }
        }
        
        lastScrollTop = st;
    }

    //Sticky header / Animations on scroll

    $(window).on('scroll', function(e){
        var lastScrollTopW = 0;
        var stW = Math.round($(window).scrollTop()/100)*100;
        var scrollBottom = stW + Math.round($(window).height()/100)*100;
        didScroll = true;

       if(innerWidth > 990) {
            if($('.services-section__scroll').length) {
                var servicesSectionTop = Math.round($('.services-section__scroll').offset().top/100)*100;
                var lifeHack = servicesSectionTop + Math.round($('.services-section__scroll').outerHeight()/100)*100;
                
            }
        }
        
        var bottom_of_object = $('footer').offset().top;
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        if( bottom_of_window > bottom_of_object ){
            $('.enquire-button').addClass('hidden');
        }
        else {
            $('.enquire-button').removeClass('hidden');
        }

        $('.contact-section__about').each( function(i){
            var bottom_of_objectS = $(this).offset().top + $(this).outerHeight() - 700;
            var bottom_of_windowS = $(window).scrollTop() + $(window).height();
            var condition = bottom_of_windowS - bottom_of_objectS ;
            if( bottom_of_windowS >= bottom_of_objectS){
                
                var scroll = $(window).scrollTop();
                if(condition >= 20) {
                   $(".contact-section__about img").css({
                        transform: 'scale(1.3)',
                    }); 
                }
                if(condition >= 150) {
                    $(".contact-section__about img").css({
                        transform: 'scale(1.2)',
                    }); 
                }
                if(condition >= 300) {
                    $(".contact-section__about img").css({
                        transform: 'scale(1.1)',
                    }); 
                }
                if(condition >= 450) {
                    $(".contact-section__about img").css({
                        transform: 'scale(1)',
                    }); 
                }
            }
        });
        $('.big-banner__image').each( function(i){
            var bottom_of_objectS = $(this).offset().top + $(this).outerHeight() - 700;
            var bottom_of_windowS = $(window).scrollTop() + $(window).height();
            var condition = bottom_of_windowS - bottom_of_objectS ;
            if( bottom_of_windowS >= bottom_of_objectS){
                
                var scroll = $(window).scrollTop();
                if(condition >= 20) {
                   $(".big-banner__image img").css({
                        transform: 'scale(1.4)',
                    }); 
                }
                if(condition >= 150) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.35)',
                    }); 
                }
                if(condition >= 300) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.3)',
                    }); 
                }
                if(condition >= 450) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.25)',
                    }); 
                }
                if(condition >= 600) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.2)',
                    }); 
                }
                if(condition >= 750) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.15)',
                    }); 
                }
                if(condition >= 900) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.1)',
                    }); 
                }
                if(condition >= 1050) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1.05)',
                    }); 
                }
                if(condition >= 1300) {
                    $(".big-banner__image img").css({
                        transform: 'scale(1)',
                    }); 
                }
            }
        });
        lastScrollTopW = stW;
    });

    if(innerWidth > 990) {

        $('.menu-nav .headnav li').each(function() {
            $(this).addClass('blue-button');
        });

        $('.headnav .blue-button').each(function() {
            var linkText = $(this).html();
            $(this).addClass('animated-button');
            $(this).contents().wrap('<span class="animated-title-1"/>')
            $(this).append('<span class="animated-title-2">' + linkText + '</span>')
        });


        $('#about-banner').on('wheel', function(e){
            var newScrollLeft = $(this).scrollLeft();
            var width = $(this).width();
            var scrollWidth = $(this).get(0).scrollWidth;
            var offset = scrollWidth - newScrollLeft - width;
            var titlesPos = $('.inner-titles__team').position();
            titlesPos = titlesPos.left;
            if(offset > 1) {
             e.preventDefault();
            }
            if(newScrollLeft >= 10) {
                $('.team-banner__image img').css('transform', 'scale(1.4)');
            }
            if(newScrollLeft >= 150) {
                $('.team-banner__image img').css('transform', 'scale(1.3)');
            }
            if(newScrollLeft >= 300) {
                $('.team-banner__image img').css('transform', 'scale(1.2)');
            }
            if(newScrollLeft >= 450) {
                $('.team-banner__image img').css('transform', 'scale(1.1)');
            }
            if(newScrollLeft >= 600) {
                $('.team-banner__image img').css('transform', 'scale(1)');
            }
            if(newScrollLeft >= 1200) {
                 $('.inner-titles__team').addClass('active');
            }
            if(newScrollLeft >= titlesPos) {
                $('.inner-titles__team').addClass('active');
            }
            $('.team-member').each(function() {
                var teamMemberPos = $(this).position();
                teamMemberPos = teamMemberPos.left;
                if(newScrollLeft >= teamMemberPos) {
                    $(this).addClass('active');
                }

            })
            $(this).scrollLeft($(this).scrollLeft() + e.originalEvent.deltaY);
        });

        /*$(document).on('mousewheel', '.services-section__scroll', function(e){
            var stW = Math.round($(window).scrollTop()/100)*100;
            var servicesSectionTop = Math.round($('.services-section__scroll').offset().top/100)*100;
            var newScrollLeft = $(this).scrollLeft();
            var width = $(this).width();
            var scrollWidth = $(this).get(0).scrollWidth;
            var offsetFull = scrollWidth - newScrollLeft - width;
            var offset = 8;
            if(stW === servicesSectionTop) {
             $(this).scrollLeft($(this).scrollLeft() + e.originalEvent.deltaY);
            }
            if(e.originalEvent.wheelDelta /120 > 0 && newScrollLeft == 0) {
                $('body').removeClass('overflow');
                $('.services-section__scroll').removeClass('fixed-section');
            }
            if (offsetFull <= offset) {
                 $('body').removeClass('overflow');
                 $('.services-section__scroll').removeClass('fixed-section');
            }
            
            
        });*/
        
    }

    //Team Button
    $(document).on('click', '.team-button', function(e) {
        e.preventDefault();
        $('#about-banner').animate( { scrollLeft: $('#about-banner').width() - 135 }, 1000 );
         $('.team-banner__image img').css('transform', 'scale(1)');
    });

    //Owl
    var owlS = $('#services-owl');
    owlS.owlCarousel({
        loop:false,
        items: 1,
        stagePadding: 20,
        nav: true,
        margin: 15,
        responsive : {
            500 : {
                items: 1,
                stagePadding: 100,
                nav: true,
                margin: 30,
            },
            990 : {
                items: 1,
                stagePadding: 100,
                nav: true,
                margin: 30,
            },
            1200 : {
                items: 1,
                stagePadding: 120,
                nav: true,
                margin: 70,
            },
            1400 : {
                items: 1,
                stagePadding: 160,
                nav: true,
                margin: 70,
            },
            1900 : {
                items: 1,
                stagePadding: 250,
                nav: true,
                margin: 70,
            },
            2200 : {
                items: 2,
                stagePadding: 140,
                nav: true,
                margin: 70,
            }
        }
      });
     owlS.on('mousewheel', '.owl-stage', function (e) {
        if (e.originalEvent.wheelDelta > 0) {
            owlS.trigger('next.owl');
        } else {
            owlS.trigger('prev.owl');
        }
        e.preventDefault();
    });

     $('#brands-owl').owlCarousel({
        items: 1,
        nav: false,
        stagePadding: 120,
        margin: 30,
        loop: true,
        autoplay: true,
        slideTransition: 'linear',
        smartSpeed: 4000,
        autoplayTimeout: 4000,
        responsive : {
            500 : {
                items: 2,
                nav: false,
                stagePadding: 120,
                margin: 30,
                loop: true,
            },
            990 : {
                items: 4,
                nav: false,
                stagePadding: 90,
                margin: 30,
                loop: true,
            },
            1200 : {
                items: 5,
                nav: false,
                stagePadding: 100,
                margin: 80,
                loop: true,
                autoWidth:true,
            }
        }
      });

     $('#testimonials-owl').owlCarousel({
        items: 1,
        loop: true,
        autoplay: false,
        nav: true,
        margin: 15,
        stagePadding: 20,
        responsive : {
            500 : {
                items: 2,
                loop: true,
                nav: true,
                margin: 30,
            },
            990 : {
                items: 3,
                loop: true,
                nav: true,
                margin: 30,
            },
            1200 : {
                items: 4,
                loop: true,
                nav: true,
                margin: 30,
            }
        }
      });

     $('#proj-services-slider').owlCarousel({
        items: 1,
        loop: false,
        autoplay: false,
        nav: false,
        margin: 8,
        autoWidth: true,
      });

    //Mobile menu
    $('.hamburger').on('click', function(e) {
        e.stopPropagation();
        $(this).toggleClass('active');
        $('.menu').addClass('active');
        $('body').addClass('overflow');
    });

    $('.close-menu').on('click', function(e) {
        e.preventDefault();
        $('.menu').removeClass('active');
        $('body').removeClass('overflow');
    });

    //Form label
    $('.checkbox-label').on('click', function() {
        $(this).toggleClass('active');
    });

    //Story row
    $('.story-row').each(function() {
        if(!$('p', this).length) {
            $('h6', this).css('margin-bottom', 0);
        }
    });

     $(".wpcf7-form-control-wrap").each(function() {
        var curLabel = $(this).prev('label').detach();
        $(this).append(curLabel);
     });

    //Form KeyPress
    $('.wpcf7-form-control-wrap input').on('keyup', function() {
        var inputLength = $(this).val().length;
        if(inputLength > 0) {
            $(this).parent().find('label').addClass('current');
        }
        else {
            $(this).parent().find('label').removeClass('current');
        }
    });

    $('.wpcf7-form-control-wrap textarea').on('keyup', function() {
        var inputLength = $(this).val().length;
        if(inputLength > 0) {
            $(this).parent().find('label').addClass('current');
        }
        else {
            $(this).parent().find('label').removeClass('current');
        }
    });

    //Cookie click
    $(document).on('click', '#cookie-law-info-again', function() {
        $(this).addClass('hiden');
    });

    //Thankyou form
       document.addEventListener("wpcf7mailsent", function( event ) {
        window.setTimeout(function(){
            if ( '138' == event.detail.contactFormId ) {
               window.location.href = "/inquiry-page/";
            }
        }, 0);
    }, false);

    var rellax = new Rellax('.rellax', {
        canter:true
    });

    //Block show animation
     AOS.init({
        duration: 1000,
        easing: 'ease-out-sine',
        once: true,
        disable: function () {
            var maxWidth = 768;
            return window.innerWidth <= maxWidth;
        }
     });

     if(innerWidth > 990) {
        var cursor = new MouseFollower({
        el: null,
        container: document.body,
        className: 'mf-cursor',
        innerClassName: 'mf-cursor-inner',
        textClassName: 'mf-cursor-text',
        mediaClassName: 'mf-cursor-media',
        mediaBoxClassName: 'mf-cursor-media-box',
        iconSvgClassName: 'mf-svgsprite',
        iconSvgNamePrefix: '-',
        iconSvgSrc: '',
        dataAttr: 'cursor',
        hiddenState: '-hidden',
        textState: '-text',
        iconState: '-icon',
        activeState: '-active',
        mediaState: '-media',
        stateDetection: {
            '-pointer': 'a,button',
            '-hidden': 'iframe'
        },
        visible: true,
        visibleOnState: false,
        speed: 0.55,
        ease: 'expo.out',
        overwrite: true,
        skewing: 0,
        skewingText: 2,
        skewingIcon: 2,
        skewingMedia: 2,
        skewingDelta: 0.001,
        skewingDeltaMax: 0.15,
        stickDelta: 0.15,
        showTimeout: 20,
        hideOnLeave: true,
        hideTimeout: 300,
        hideMediaTimeout: 300
        });
     }

});